'use strict';

var simpleListCtrl = [function() {
  var _this =this;

  

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            form: '=',reportConfig:'='
        },
        controller: simpleListCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/simpleListDirective.html'
    };
};
